import { Link } from 'react-router-dom'
import React, { useEffect } from 'react'

function Rider(props) {
  const [theme, setTheme] = React.useState('')

  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div
      className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}
      style={{ marginBottom: '-90px' }}
    >
      <div className="main-wrapper inner--page rider-page">
        <section
          className="hero-banner inner-banner form-page"
          style={{ backgroundImage: `url('images/rider-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-10 col-md-12 col-sm-12">
                <div className="partner-banner-content pt-183">
                  <h1>
                    Sign up today
                    <br /> and become a Roadie!
                  </h1>
                  <text>
                    We offer you complete control over your earning potential
                    with an easy-to-understand user interface that connects
                    orders, restaurants, and you. Want to learn more?{' '}
                  </text>
                </div>
                <div className="mt-5 mb-3">
                  <Link to="/riderregistration">
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-2 col-md-12 col-sm-12">
                {/* 
								<div className="col-lg-12" style={{ marginTop: 20 + 'em', float: 'ringht' }}>
									<Link to="/riderregistration">
										<button className="primary-btn">Join Us</button>
									</Link>
								</div> */}
              </div>
            </div>
          </div>
        </section>

        <section className="benefit-sec lgreen-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/riders_page/greenlpatecar2-magni.jpg"
                    width="716.66"
                    height="427.81"
                    alt="Be Your own Boss"
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="benefit-content">
                  <h2>Green means GO!</h2>
                  <br />
                  <label>
                    At RoadJockey we play by all the rules with operating and
                    providing the best service. Having a green plate is{' '}
                    <b>required</b> to do deliveries with us. Please take a
                    moment to either check your Green Plate status or sign-up
                    for one at the Transportation Authority by clicking this{' '}
                    <a href="https://www.ta.org.jm/">link </a>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="benefit-sec yellow-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="benefit-content">
                  <h2>Increase Your Earnings</h2>
                  <br />
                  <label>
                    Being a RoadJockey Roadie is a great way to put some extra
                    earnings in your pocket. Whether you need some home repairs,
                    are saving up for a new car, or just want to bring in more
                    resources for the family, we are here to help.{' '}
                  </label>
                </div>
                <div className="mt-5 mb-3 ml-5">
                  <Link to="/riderregistration">
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/riders_page/african-delivery-man.jpg"
                    width="716.66"
                    height="427.81"
                    alt="Get Instant"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/riders_page/jamaican-dollars.jpg"
                    width="716.66"
                    height="427.81"
                    alt="Earn More"
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="benefit-content">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <h2>Complete Freedom</h2>
                  <br />
                  <label>
                    With RoadJockey, you set the hours. There is no boss
                    breathing over your shoulder. You provide a quality service
                    with the well-known kindness of the island, and we provide
                    the earning opportunities. Every time you make a delivery,
                    your account grows!
                  </label>
                </div>
                <div className="mt-5 mb-3">
                  <Link to="/riderregistration">
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="benefit-sec lgreen-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="benefit-content">
                  <h2>Benefits of Service</h2>
                  <br />
                  <label>
                    Every delivery presents a chance to increase your earnings.
                    When you make a successful, on-time delivery in a friendly
                    and professional manner, you have the potential to increase
                    your tips. The more tips you make, the more you bring home!
                  </label>
                </div>
                <div className="mt-5 mb-3 ml-5">
                  <Link to="/riderregistration">
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/riders_page/rider1.jpg"
                    width="716.66"
                    height="427.81"
                    alt="Be Your own Boss"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="benefit-sec lgreen-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div>
                  <a href="https://apps.apple.com/us/app/road-jockey-rider/id1595611153">
                    <img
                      className="m-3"
                      src="https://roadjockey.com/images/img-apple-btn.png"
                      style={{ height: '100px' }}
                    />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.roadjockey.rider">
                    <img
                      className="m-3"
                      src="https://roadjockey.com/images/img-google-btn.png"
                      style={{ height: '100px' }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-lg-5">
                <div>
                  <p className="mt-5">
                    <h3 className="mr-4" style={{ color: '#352E49' }}>
                      Deliveries Expedited with our App.
                    </h3>
                  </p>
                  <br />
                  <label>
                    Get the Roadies app on both google play and app store
                  </label>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Rider
